import React from 'react';

import styles from "./PaymentWays.scss";
import epayImg from "./img/epay.png";
import bpayImg from "./img/bpay.png";
import paypalImg from "./img/paypal.png";
import easyImg from "./img/easypay.png";
import bankImg from "./img/bank.png";
import transImg from "./img/trans.png";
import visaImg from "./img/visa.png";
import masterImg from "./img/mastercard.png";
import borikaImg from "./img/borika.png";
import clubImg from "./img/club.png";
import jcbImg from "./img/jcb.png";
import discImg from "./img/discover.png";
import aeImg from "./img/aexpress.png";
import twoCheckoutImg from "./img/2ch.png";
import {__t} from '../../common/lang/text-resource';

function showTooltip(tooltip) {
	document.getElementById(tooltip).style.display = "block";
}

function hideTooltip(tooltip) {
	document.getElementById(tooltip).style.display = "none";
}

const PaymentWaysBG = () => {
	return (
	  <section className={styles.paymentWay}>
		  <div data-layout="row start center gutter-none">
			  <div data-layout="col 12 3@sm 8@tb">
				  <div className={styles.firstRow} data-layout="row gutter-none between">
					  <div data-layout="col 12 text-left">
						  <a
							href={__t("https://help.superhosting.bg/payment-methods.html")}
							target="_blank"
							rel="noopener noreferrer"
							title={__t("Начини на плащане")}>{__t("Начини на плащане")}</a>
					  </div>
				  </div>
				  <table className={styles.secondRow}>
					  <tbody>
					  <tr>
						  <td
							onMouseEnter={() => showTooltip('epayttp')}
							onMouseLeave={() => hideTooltip('epayttp')}>
							  <img src={epayImg} alt="ePay"/>
							  <span>{__t("ePay")}</span>
							  <div className={styles.paymentWayTooltip} id="epayttp">
								  <strong>{__t("Плащане през ePay")}</strong>
								  <br/>
								  {__t('плащането-се-извършва-след-предварителна-регистра2b8c60')}
							  </div>
						  </td>
						  <td
							onMouseEnter={() => showTooltip('bpayttp')}
							onMouseLeave={() => hideTooltip('bpayttp')}>
							  <img src={bpayImg} alt={__t("B-Pay (банкомат)")}/>
							  <span>{__t("B-Pay (банкомат)")}</span>
							  <div className={styles.paymentWayTooltip} id="bpayttp">
								  <strong>{__t("B-Pay (банкомат)")}</strong>
								  <br/>
								  <br/>
								  {__t("Необходимо е да посетите")}&nbsp;
								  <strong>{__t("B-Pay банкомат")}</strong>&nbsp;
								  {__t('и-да-извършите-заплащане-чрeз-дебитна-или-кредитнc58cda')}
								  <br/>
								  <br/>
								  {__t("Въведете код на търговец")}
								  <br/>
								  (<strong>{__t("60 000")}</strong>),
								  {__t('както-и-персоналния-10-цифрен-код-който-сме-ви-изcba12c')}
							  </div>
						  </td>
						  <td
							onMouseEnter={() => showTooltip('paypalttp')}
							onMouseLeave={() => hideTooltip('paypalttp')}>
							  <img src={paypalImg} alt={__t("PayPal")}/>
							  <span>{__t("PayPal")}</span>
							  <div className={styles.paymentWayTooltip} id="paypalttp">
								  <strong>{__t("PayPal")}</strong>
								  <br/>
								  {__t('плащането-се-извършва-след-предварителна-регистраfb7f8c')}
							  </div>
						  </td>
						  <td
							onMouseEnter={() => showTooltip('easypayttp')}
							onMouseLeave={() => hideTooltip('easypayttp')}>
							  <img src={easyImg} alt={__t("EasyPay")}/>
							  <span>{__t("EasyPay")}</span>
							  <div className={styles.paymentWayTooltip} id="easypayttp">
								  <strong>{__t("EasyPay")}</strong>
								  <br/>
								  {__t('плащането-може-да-се-извърши-във-всеки-клон-каса-2094fe')}
								  <br/>
								  {__t('при-онлайн-поръчката-през-нашия-сайт-се-генерира-8e43c5')}
							  </div>
						  </td>
						  <td
							onMouseEnter={() => showTooltip('bankttp')}
							onMouseLeave={() => hideTooltip('bankttp')}>
							  <img src={bankImg} alt={__t("Банков превод")}/>
							  <span>{__t("Банков превод")}</span>
							  <div className={styles.paymentWayTooltip} id="bankttp">
								  <strong>{__t("Банков превод")}</strong>
								  <br/>
								  {__t('заплащането-се-извършва-чрез-банков-превод-на-сум89cda2')}
							  </div>
						  </td>
						  <td
							onMouseEnter={() => showTooltip('transttp')}
							onMouseLeave={() => hideTooltip('transttp')}>
							  <img src={transImg} alt={__t("Transcard")}/>
							  <span>{__t("Transcard")}</span>
							  <div className={styles.paymentWayTooltip} id="transttp">
								  <strong>{__t("Transcard")}</strong>
								  <br/>
								  {__t('плащането-се-извършва-през-уеб-сайта-на-Transcardcb6bab')}
							  </div>
						  </td>
					  </tr>
					  </tbody>
				  </table>
			  </div>
			  <div
				data-layout="col 12 3@sm 4@tb text-left"
				className={styles.pRel}>
				  <p>{__t("Кредитни карти")}</p>
				  <table
					className={styles.cardsTable}
					onMouseEnter={() => showTooltip('visattp')}
					onMouseLeave={() => hideTooltip('visattp')}>
					  <tbody>
					  <tr>
						  <td>
							  <div className={styles.centerCards}>
								  <img src={visaImg} alt={__t("Visa")}/>
								  <span>{__t("Visa")}</span>
							  </div>
						  </td>
						  <td>
							  <div className={styles.centerCards}>
								  <img src={masterImg} alt={__t("Master Card")}/>
								  <span>{__t("MasterCard")}</span>
							  </div>
						  </td>
						  <td>
							  <div className={styles.centerCards}>
								  <img src={borikaImg} alt={__t("Борика")}/>
								  <span>{__t("Borica")}</span>
							  </div>
						  </td>
					  </tr>
					  </tbody>
				  </table>
				  <div className={styles.paymentWayTooltip} id="visattp">
					  <strong>{__t("Кредитни карти")}</strong>
					  <br/>
					  {__t('заплащането-може-да-се-извърши-през-системата-на-79efc0')}
					  <br/>
					  {__t("Поддържат се")}&nbsp;
					  <em>{__t("VISA, Master Card, Maestro")}</em>
					  {__t(", дебитни карти и др.")}
				  </div>
			  </div>
		  </div>
	  </section>
	);
};
const PaymentWaysEN = () => {
	return (
	  <div className={styles.en}>
		  <section className={styles.paymentWay}>
			  <div data-layout="row start gutter-none">
				  <div data-layout="col 12">
					  <div className={styles.firstRow} data-layout="row gutter-none between">
						  <div data-layout="col 12 text-left">
							  <a
								href="https://help.superhosting.bg/payment-methods.html"
								target="_blank"
								rel="noopener noreferrer"
								title={__t('Начини на плащане')}>{__t("Начини на плащане")}</a>
						  </div>
					  </div>
					  <p className={styles.tableLabel}>{__t("Кредитни карти")}</p>
					  <div className={styles.pRel}>
						  <table
							className={styles.secondRow}
							onMouseEnter={() => showTooltip('visattp')}
							onMouseLeave={() => hideTooltip('visattp')}>
							  <tbody>
							  <tr>
								  <td>
									  <img src={visaImg} alt={__t("Visa")}/>
								  </td>
								  <td>
									  <img src={clubImg} alt={__t("DIners Club")}/>
								  </td>
								  <td>
									  <img src={masterImg} alt={__t("Master Card")}/>
								  </td>
								  <td>
									  <img src={jcbImg} alt={__t("JCB")}/>
								  </td>
								  <td>
									  <img src={aeImg} alt={__t("American Express")}/>
								  </td>
								  <td>
									  <img src={discImg} alt={__t("Discover Card")}/>
								  </td>
								  <td>
									  <img src={borikaImg} alt={__t("Борика")}/>
								  </td>
								  <td>
									  <img src={twoCheckoutImg} alt={__t("2Checkout")}/>
								  </td>
							  </tr>
							  </tbody>
						  </table>
						  <div data-layout="text-left" className={styles.paymentWayTooltip} id="visattp">
							  <strong>{__t("Кредитни карти")}</strong><br/>
							  {__t('заплащането-може-да-се-извърши-през-системата-на-79efc0')}
							  <br/>
							  {__t("Поддържат се")}&nbsp;
							  <em>{__t("VISA, Master Card, Maestro")}</em>
							  {__t(", дебитни карти и др.")}
						  </div>
					  </div>
					  <table className={styles.secondRow}>
						  <tbody>
						  <tr>
							  <td>
								  <span>{__t("PayPal")}</span>
							  </td>
							  <td
								onMouseEnter={() => showTooltip('paypalttp')}
								onMouseLeave={() => hideTooltip('paypalttp')}>
								  <img src={paypalImg} alt={__t("PayPal")}/>
								  <div className={styles.paymentWayTooltip} id="paypalttp">
									  <strong>{__t("PayPal")}</strong>
									  <br/>
									  {__t('плащането-се-извършва-след-предварителна-регистраfb7f8c')}
								  </div>
							  </td>
							  <td>
								  Bank transfer&nbsp;
							  </td>
							  <td
								onMouseEnter={() => showTooltip('bankttp')}
								onMouseLeave={() => hideTooltip('bankttp')}>
								  <img src={bankImg} alt={__t("Банков превод")}/>
								  <div className={styles.paymentWayTooltip} id="bankttp">
									  <strong>{__t("Банков превод")}</strong>
									  <br/>
									  {__t('заплащането-се-извършва-чрез-банков-превод-на-сум89cda2')}
								  </div>
							  </td>
						  </tr>
						  </tbody>
					  </table>
				  </div>
			  </div>
		  </section>
	  </div>
	);
};

const PaymentWays = () => {
	return <PaymentWaysBG/>;
};

export default PaymentWays;